module.exports = __webpack_public_path__ + "4fd7a43663a8a4fe7aa801e1a63be0c5.svg";